import { initializeBrowserLocale } from '@repo/i18n/browser';
import { LocaleRoot } from './components/locale-root';
/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import './index.css';
import { router } from './routes';

initializeBrowserLocale();

const elem = document.getElementById('root')!;
const app = (
  <StrictMode>
    <LocaleRoot>
      <RouterProvider router={router} />
    </LocaleRoot>
  </StrictMode>
);
if (import.meta.hot) {
  // With hot module reloading, `import.meta.hot.data` is persisted.
  // biome-ignore lint/suspicious/noAssignInExpressions: bun template
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  // The hot module reloading API is not available in production.
  createRoot(elem).render(
    <LocaleRoot>
      <RouterProvider router={router} />
    </LocaleRoot>,
  );
}
